var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmutedMicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.996 300.138C239.608 300.138 223.89 293.628 212.302 282.039C200.713 270.451 194.203 254.734 194.203 238.345V97.1037C194.203 88.9889 195.801 80.9535 198.907 73.4565C202.012 65.9594 206.564 59.1473 212.302 53.4093C218.04 47.6713 224.852 43.1197 232.349 40.0143C239.846 36.9089 247.881 35.3105 255.996 35.3105C264.111 35.3105 272.146 36.9089 279.643 40.0143C287.141 43.1197 293.953 47.6713 299.691 53.4093C305.429 59.1473 309.98 65.9594 313.086 73.4565C316.191 80.9535 317.789 88.9889 317.789 97.1037V238.345C317.789 254.734 311.279 270.451 299.691 282.039C288.102 293.628 272.385 300.138 255.996 300.138Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.103 176.552V238.345C353.103 291.875 309.53 335.448 256 335.448C202.469 335.448 158.896 291.875 158.896 238.345V176.552H123.586V238.345C123.586 305.364 173.674 360.766 238.345 369.435V441.379H176.551V476.69H335.448V441.379H273.655V369.435C338.326 360.766 388.414 305.364 388.414 238.345V176.552H353.103Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmutedMicIcon);
export default __webpack_public_path__ + "static/media/unmuted_mic_ico n.fe94003ded4a85f2cf2cf39f48fd8993.svg";
export { ForwardRef as ReactComponent };